import { gql } from "@apollo/client";

export const BUYER_DASHBOARD_QUERY = gql`
	query BuyerDashboard($params: UserQueryParams) {
		user(params: $params) {
			groupOne {
				buyerUnits {
					id
					interestedInProject
					visitRequested
					cancellation {
						flag
						at
					}
					processDetails {
						process
						stage
						status
					}
					unit {
						_id
						id
						name
					}
				}
				buyerProjects {
					id
					interestedInProject
					visitRequested
					locality
					cancellation {
						flag
					}
					processDetails {
						process
						stage
						status
					}
					project {
						id
						name
					}
					sellerProject {
						id
					}
				}
				members {
					emails {
						address
					}
					phones {
						number
					}
					designation
				}
				processDetails {
					status
					process
					stage
				}
			}
		}
	}
`;

export const BUYER_DASHBOARD_SUGGESTION_LIST_QUERY = gql`
	query GetSuggestedProperties($params: BuyerQueryParams) {
		buyer(params: $params) {
			getSuggestedProperties {
				unitId
				type
				status
				propertyTypes
				projectName
				projectId
				price
				parking
				locality
				landParcel
				facings
				cover
				builtUpAreas
				bedroom
				bathrooms
				balconies
				preferenceId
			}
		}
	}
`;

export const BUYER_ACTIONS_MUTATION = gql`
	mutation BuyerActions($params: BuyerParams) {
		buyer(params: $params) {
			buyerActions
		}
	}
`;

export const BUYER_OFFERS_QUERY = gql`
	query GetBuyerOffers($params: BuyerQueryParams) {
		buyer(params: $params) {
			getBuyerOffers {
				_id
				supId
				unitId
				projectId
				review {
					price
					note
				}
				createdAt
				updatedAt
			}
		}
	}
`;
